import { validateDateRange } from '~support-at-home/lib/validate';

import { Step } from '~components/wizard-form/props';
import ListAndConfirm from '~support-at-home/components/budgets/bulk-copy/ListAndConfirm';
import Review from '~support-at-home/components/budgets/bulk-copy/Review';

import { getAll as getClients } from '~main/actions/clients';
import { getAll as getStatuses } from '~support-at-home/actions/clientBudgetStatuses';
import { getAll as getFundingTypes } from '~support-at-home/actions/fundingTypes';

import { selectLookupClients } from '~main/selectors/clients/clients';
import { selectClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';
import { selectLookupFundingTypes } from '~support-at-home/selectors/fundingTypes';

const bulkCopyFields: Step[] = [
  {
    step: 1,
    title: 'Criteria',
    fields: {
      date_range: {
        type: 'date-range',
        field: 'date_range',
        required: true,
        caption: 'Date Range',
        description: 'Select the date range for the END date of the budgets to be copied.',
        validate: (values: any) =>
          validateDateRange({ start_date: values.date_range?.gte, end_date: values.date_range?.lte }),
      },
      status_ids: {
        type: 'multi-lookup',
        field: 'status_ids',
        caption: 'Budget Status',
        selectorOptions: selectClientBudgetStatuses,
        selectorActions: getStatuses,
      },
      funding_type_ids: {
        type: 'multi-lookup',
        field: 'funding_type_ids',
        caption: 'Funding Type',
        selectorOptions: selectLookupFundingTypes,
        selectorActions: getFundingTypes,
      },
      client_ids: {
        type: 'multi-lookup',
        field: 'client_ids',
        caption: 'Clients',
        selectorOptions: selectLookupClients,
        selectorActions: getClients,
      },
    },
  },
  {
    step: 2,
    title: 'Confirm Budgets to Copy',
    fields: {
      // Need to pass found budgets to field value to then use in step 3
      budget_ids: {
        type: 'custom',
        component: ListAndConfirm,
        dependencies: ['date_range', 'funding_type_ids', 'client_ids', 'status_ids'],
        colSize: 12,
      },
      start_date: {
        type: 'date',
        field: 'start_date',
        caption: 'New Start Date',
        required: true,
        show: (values) => {
          return values.budget_ids && values.budget_ids.length > 0;
        },
      },
      end_date: {
        type: 'date',
        field: 'end_date',
        caption: 'New End Date',
        required: true,
        show: (values) => {
          return values.budget_ids && values.budget_ids.length > 0;
        },
        validate: (values) => validateDateRange({ start_date: values.start_date, end_date: values.end_date }),
      },
    },
    nextButtonCaption: 'Confirm Copy',
    showNextButton: ({ values }) => {
      // Only allow next step if there are budgets to copy
      const budgetsData = values?.budget_ids;
      return budgetsData?.length > 0;
    },
  },
  {
    step: 3,
    title: 'Review',
    fields: {
      copy_progress: {
        type: 'custom',
        component: Review,
        dependencies: ['budget_ids', 'start_date', 'end_date'],
        colSize: 12,
      },
    },
    showPrevButton: false,
  },
];

export default bulkCopyFields;
